import { useGeoState, useGeoFetch } from '../../components/GeoProvider'
import React, { useState, useEffect, useRef } from 'react'
import BottomBarGraph from './BottomBarGraph';

const getVaccineColor = (vaccineIndex, vaccineCount) => {
  const colorStops = ['#c71e83', '#15A796', '#AEE2D5'];
  const colorPosition = vaccineCount === 1
    ? 1
    : (vaccineIndex / (vaccineCount - 1)) * (colorStops.length - 1);
  const lowerColorIndex = Math.floor(colorPosition);
  const upperColorIndex = Math.min(lowerColorIndex + 1, colorStops.length - 1);
  const interpolation = colorPosition - lowerColorIndex;

  const getRgb = (hexColor) => hexColor.match(/[A-Fa-f0-9]{2}/g)
    .map(value => parseInt(value, 16));
  const lowerColor = getRgb(colorStops[lowerColorIndex]);
  const upperColor = getRgb(colorStops[upperColorIndex]);
  const rgbColor = lowerColor.map((value, channelIndex) => Math.round(
    value + (upperColor[channelIndex] - value) * interpolation
  ));

  return `rgb(${rgbColor.join(', ')})`;
};

const AgeGenderGraph = () =>{
   const [getVaccineTable, setVaccineTable] = useState() 
   const [getSeriesMale, setSeriesMale] = useState()
   const [getSeriesFemale, setSeriesFemale] = useState()
   const [getCategories, setCategories] = useState()
    const [errorCode, setErrorCode] = useState()
      const [errorMessage, setErrorMessage] = useState()
      const [errorSubject, setErrorSubject] = useState()
      const [errorOccured, seterrorOccured] = useState(false)
const { getRefreshDateFilter, getStateFilter, getAgeGroupFilter, getGenderFilter,
        getVaccineTypeFilter,getMemberTypeFilter } =
        useGeoState()

const { data: vaccineTableData, error: VaccineDataError } = useGeoFetch(
    '',
    '',
    'vaccineAgeGenderData',
    'STATE',
    {geo_parent:'US',refresh_date:getRefreshDateFilter,state:getStateFilter,gender:getGenderFilter,age_group:getAgeGroupFilter,vaccine_type:getVaccineTypeFilter,module_name:'SHINGLES',member_type:getMemberTypeFilter},
    'POST'
  )

  useEffect(() => {
    if (vaccineTableData !== null && vaccineTableData !== undefined) {
      if (vaccineTableData.response_code === 200) {
        setVaccineTable(vaccineTableData.response_data)
      } else {
        setErrorCode(vaccineTableData.response_code)
        setErrorMessage(vaccineTableData.response_message)
        setErrorSubject(vaccineTableData.response_subject)
        seterrorOccured(true)
      }
    }
  }, [vaccineTableData])

    var seriesMale = [];
    var seriesFemale = [];
    var ageGroups = [];
    var Vaccines = [];
 
  
  function ProcessData(){
    ageGroups = [
    ...new Set(getVaccineTable.map(item => item.age_group).filter(Boolean))
    ];
    setCategories(ageGroups);

    Vaccines = [
    ...new Set(getVaccineTable.map(item => item.vaccine_type).filter(Boolean))
    ];

    if (getGenderFilter.toLowerCase() == 'male'){
        const maleData =  getVaccineTable;
        Vaccines.forEach((item, vaccineIndex) => {
        var data = [];
        ageGroups.forEach((agegrp) => {
            var filteredData = maleData.filter(data => data.vaccine_type.toLowerCase() == item.toLowerCase() 
             && data.age_group.toLowerCase() == agegrp.toLowerCase());
             
            data.push(filteredData.length === 0 ? 0 : parseInt(filteredData[0].count));
        })

        seriesMale.push({name:item, data:data, color:getVaccineColor(vaccineIndex, Vaccines.length)});
        seriesFemale = [];
    })
    setSeriesMale(seriesMale);
    setSeriesFemale([]);
    }
    else if (getGenderFilter.toLowerCase() == 'female'){
        const femaleData = getVaccineTable;
    Vaccines.forEach((item, vaccineIndex) => {
        var data = [];
        ageGroups.forEach((agegrp) => {
            var filteredData = femaleData.filter(data => data.vaccine_type.toLowerCase() == item.toLowerCase() 
            &&  data.age_group.toLowerCase() == agegrp.toLowerCase());
             
            data.push(filteredData.length === 0 ? 0 : parseInt(filteredData[0].count));
        })

        seriesFemale.push({name:item, data:data, color:getVaccineColor(vaccineIndex, Vaccines.length)});
        seriesMale = [];
    })
        setSeriesFemale(seriesFemale);
        setSeriesMale([]);
    }
    else{
        const maleData = getVaccineTable.filter(item => 
            (item.gender || "").toLowerCase() === "male"
        );
        Vaccines.forEach((item, vaccineIndex) => {
        var data = [];
        ageGroups.forEach((agegrp) => {
  
            var filteredData = maleData.filter(data => data.vaccine_type.toLowerCase() == item.toLowerCase() 
            &&  data.age_group.toLowerCase() == agegrp.toLowerCase());
             console.log("filteredData",filteredData)
            data.push(filteredData.length === 0 ? 0 : parseInt(filteredData[0].count));
        })

        seriesMale.push({name:item, data:data, color:getVaccineColor(vaccineIndex, Vaccines.length)});
    })
        setSeriesMale(seriesMale);

          const femaleData = getVaccineTable.filter(item => 
            (item.gender || "").toLowerCase() === "female"
        );
        Vaccines.forEach((item, vaccineIndex) => {
        var data = [];
        ageGroups.forEach((agegrp) => {
            var filteredData = femaleData.filter(data => data.vaccine_type.toLowerCase() == item.toLowerCase() 
            &&  data.age_group.toLowerCase() == agegrp.toLowerCase());
             
            data.push(filteredData.length === 0 ? 0 : parseInt(filteredData[0].count));
        })

        seriesFemale.push({name:item, data:data, color:getVaccineColor(vaccineIndex, Vaccines.length)});
    })
        setSeriesFemale(seriesFemale);
    }
  } 

  useEffect(() =>{
    
  if(getVaccineTable!==undefined){
     seriesMale = [];
     seriesFemale = [];
     ProcessData();
  }
  },[getVaccineTable])
   

return (
  <>
    {getVaccineTable && getSeriesMale && getSeriesFemale && getCategories ? (
      <BottomBarGraph
        seriesMale={getSeriesMale}
        seriesFemale={getSeriesFemale}
        categories={getCategories}
      />
    ) : null}
  </>
)
};

export default AgeGenderGraph;
